import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const AccessDenied: React.FC = () => {
	return (
		<Box display="flex" justifyContent="center" mt="15vh">
			<Card sx={{ maxWidth: 480, width: "100%", textAlign: "center" }}>
				<CardContent sx={{ p: 4 }}>
					<LockOutlinedIcon sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
					<Typography variant="h5" color="error" gutterBottom>
						Access Denied
					</Typography>
					<Typography color="text.secondary">
						You do not have permission to access the Pastoral Admin.
					</Typography>
					<Typography color="text.secondary" sx={{ mt: 1.5 }}>
						This application is available to active staff only. Please contact
						your system administrator if you believe you should have access.
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
};

export default AccessDenied;
